export interface EmailJSConfig {
    SERVICE_ID: string;
    TEMPLATE_ID: string;
    PUBLIC_KEY: string;
}

export const EMAILJS_CONFIG: EmailJSConfig = {
    SERVICE_ID: 'service_uk5f4nz',
    TEMPLATE_ID: 'template_ldxbrp7',
    PUBLIC_KEY: 'cMVzMcmj8nl0IjvSc',
};

export default EMAILJS_CONFIG;
